import { StyleSheet } from "react-native";
import { Dimensions, Platform } from "react-native";
let deviceHeight = Dimensions.get("window").height;

export default StyleSheet.create({
  mainContainer: {
    flex: 1,
    width: "100%",
    height: deviceHeight,
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
  },

  logoView: {
    justifyContent: "center",
    width: "100%",
    height: 70,
  },
  logoImage: {
    marginLeft: 30,
    height: 39,
    width: 111,
  },

  headerView: {
    width: "100%",
    height: 76,
    padding: 30,
    justifyContent: "center",
  },

  textMonthlyPayment: {
    height: 34,
    fontWeight: "600",
    textAlign: "left",
    color: "white",
    fontSize: Platform.OS == "web" ? 26 : 20,
  },

  bodyContainer: {
    width: "100%",
    paddingLeft: "14%",
    paddingRight: "14%",
    paddingBottom: "5%",
    paddingTop: "5%",
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
  },

  bodyContainer_SMALL_MOBILE: {
    width: "100%",
    paddingLeft: "3%",
    paddingRight: "3%",
    paddingBottom: "2%",
    paddingTop: "2%",
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
  },
  bodyContainer_MEDIUM_MOBILE: {
    width: "100%",
    paddingLeft: "10%",
    paddingRight: "10%",
    paddingBottom: "2%",
    paddingTop: "2%",
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
  },
  bodyContainer_LARGE_MOBILE: {
    width: "100%",
    paddingLeft: "10%",
    paddingRight: "10%",
    paddingBottom: "2%",
    paddingTop: "2%",
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
  },
  bodyContainer_SMALL_TABLET: {
    width: "100%",
    paddingLeft: "3%",
    paddingRight: "3%",
    paddingBottom: "2%",
    paddingTop: "2%",
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
  },

  fieldContainers: {
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#e9e9e9",
    padding: 20,
    borderRadius: 20,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
  },
  totalAmount: {
    alignSelf: "center",
    fontSize: 16,
    fontFamily: Platform.OS === "ios" ? "SFProTextbold" : "SFProText",
    color: "#273a4e",
    fontFamily: "SFProText",
    fontWeight: "normal",
    display: "flex",
    justifyContent: "center",
    color: "black",
    textAlign: "center",
  },
  amountBold: { fontWeight: "bold" },
  amountBoldIOS: { fontFamily: "SFProTextbold", fontWeight: "bold" },
  paddingTopBottom: {
    paddingTop: 10,
    paddingBottom: 10,
  },
  internetBankingImageView: {
    justifyContent: "flex-start",
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    height: 70,
    width: "100%",
  },
  internetBankImage: {
    width: 45.2,
    height: 33.5,
  },

  txtBankDetail: {
    fontSize: 17,
    marginLeft: 20,
    color: "#273a4e",
    fontFamily: Platform.OS === "ios" ? "SFProTextbold" : "SFProText",
    fontFamily: "SFProText",
  },
  textInputView: {
    borderColor: "#f6f6f6",
    borderWidth: 0,
    justifyContent: "center",
    alignSelf: "center",
    padding: 0,
    paddingBottom: 20,
    textAlign: "left",
  },
  textInput:
    Platform.OS == "web"
      ? {
          borderColor: "#f6f6f6",
          outlineStyle: "solid",
          outlineWidth: 0,
          width: 478,
          height: 48,
          backgroundColor: "#f6f6f6",
          paddingBottom: 10,
          paddingLeft: 15,
          paddingTop: 10,
          fontSize: 16,
          fontFamily: "SFProText",
          color: "black",
          borderRadius: 7,
        }
      : {
          width: 478,
          height: 48,
          backgroundColor: "#f6f6f6",
          paddingBottom: 10,
          paddingLeft: 15,
          paddingTop: 10,
          fontSize: 16,
          fontFamily: "SFProText",
          color: "black",
          borderRadius: 7,
        },
  textInputError: {
    fontSize: 12,
    textAlign: "left",
    color: "red",
    fontFamily: "SFProText",
  },
  textInputErrorView: {
    textAlign: "left",
    marginTop: 3,
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  textInputErrorView_SMALL_MOBILE: {
    width: "90%",
  },
  textInputErrorView_MEDIUM_MOBILE: {
    width: "90%",
  },
  textInputErrorView_LARGE_MOBILE: {
    width: "90%",
  },
  textInputErrorView_SMALL_TABLET: {
    width: "90%",
  },
  textInputErrorView_MEDIUM_TABLET: {
    width: "90%",
  },
  textInputErrorView_LARGE_TABLET: {
    width: "80%",
  },
  textInputErrorView_LAPTOP: {
    width: "100%",
  },
  textInputView_SMALL_MOBILE: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  textInputView_MEDIUM_MOBILE: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  textInputView_LARGE_MOBILE: {
    justifyContent: "center",
    alignItems: "center",
    width: "90%",
  },
  textInputView_SMALL_TABLET: {
    justifyContent: "center",
    alignItems: "center",
    width: "90%",
  },
  textInputView_MEDIUM_TABLET: {
    justifyContent: "center",
    alignItems: "center",
    width: "90%",
  },
  textInputView_LARGE_TABLET: {
    justifyContent: "center",
    alignItems: "center",
    width: "90%",
  },
  textInputView_LAPTOP: {
    justifyContent: "center",
    alignItems: "center",
  },

  textInputResponsive_SMALL_MOBILE: {
    width: "100%",
    fontSize: 12,
  },
  textInputResponsive_MEDIUM_MOBILE: {
    width: "100%",
    fontSize: 12,
  },
  textInputResponsive_LARGE_MOBILE: {
    width: "90%",
    fontSize: 14,
  },
  textInputResponsive_SMALL_TABLET: {
    width: "90%",
  },
  textInputResponsive_MEDIUM_TABLET: {
    width: "90%",
  },
  textInputResponsive_LARGE_TABLET: {},
  textInputResponsive_LAPTOP: {},

  paynowBtnView: {
    justifyContent: "center",
    alignItems: "center",
  },

  payBtn: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#ed705b",
    width: 159,
    height: 48,
    color: "white",
    borderRadius: 65,
  },

  txtPayNow: {
    color: "white",
    fontSize: 16,
    fontFamily: "SFProText",
  },
  backgroundWhite: { backgroundColor: "white" },
  textInputRes_SMALL_MOBILE: {
    width: "100%",
    fontSize: 12,
  },
  textInputRes_MEDIUM_MOBILE: {
    width: "100%",
    fontSize: 14,
  },
  textInputRes_LARGE_MOBILE: {
    width: "100%",
    fontSize: 16,
  },
  textInputRes_SMALL_TABLET: {
    width: "100%",
  },
  textInputRes_MEDIUM_TABLET: {
    width: "90%",
  },
  textInputRes_LARGE_TABLET: {},
  textInputRes_LAPTOP: {},
  headerStyle: {
    backgroundColor: "#f6f6f6",
    borderColor: "#f6f6f6",
    borderRadius: 7,
    height: 48,
    justifyContent: "center",
    paddingLeft: 15,
  },
  dropDownHeaderTextSTyle: {
    fontSize: 12,
    color: "grey",
    fontFamily: "SFProText",
    width: "90%",
  },
  dropDownHeaderTextSTyleResponsive_SMALL_MOBILE: {
    fontSize: 12,
  },
  dropDownHeaderTextSTyleResponsive_MEDIUM_MOBILE: {
    fontSize: 14,
  },
  dropDownHeaderTextSTyleResponsive_LARGE_MOBILE: {
    fontSize: 16,
  },
  dropDownHeaderTextSTyleResponsive_SMALL_TABLET: {},
  dropDownHeaderTextSTyleResponsive_MEDIUM_TABLET: {},
  dropDownHeaderTextSTyleResponsive_LARGE_TABLET: {},
  dropDownHeaderTextSTyleResponsive_LAPTOP: {},
  borderWidth0: {
    borderWidth: 0,
  },
});
